import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';

import { ChakraProvider } from '@chakra-ui/react';
import { MoralisProvider } from 'react-moralis';
import '../../theme/formstyles.css';
import '../../lib/i18n/i18n';
import * as Sentry from '@sentry/react';
import { BlockchainProvider } from '../../providers/Blockchain/blockchainProvider';
import { MarketProvider } from '../../providers/Market/marketProvider';
import { CartridgeCreatorProvider } from '../../providers/Cartridge/cartridgeProvider';
import { PolygonLabel } from './PolygonLabel/polygonLabel';
import Wrapper from './Wrapper/Wrapper';
import { customTheme } from '../../theme/customTheme';
import { config } from 'src/config';

const App = Sentry.withProfiler(() => {
	return (
		<MoralisProvider
			appId={config.moralis.appId}
			serverUrl={config.moralis.dappUrl}
		>
			<BlockchainProvider>
				<MarketProvider>
					<CartridgeCreatorProvider>
						<ChakraProvider
							theme={customTheme}
							resetCSS
						>
							<PolygonLabel />
							<Wrapper />
						</ChakraProvider>
						<ToastContainer />
					</CartridgeCreatorProvider>
				</MarketProvider>
			</BlockchainProvider>
		</MoralisProvider>
	);
});

export default App;
